export enum ELacProcessTypes
{
    PhysiqueChimieInSitu = 1,
    PrelEauIntegre = 2,
    PrelEauPonctuel = 4,
    PrelSediment = 8,
    PrelPhyto = 16
}